// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__Jd3-Z","filesListContainer":"PosDisputesFiles_filesListContainer__3Q5NR","filesButton":"PosDisputesFiles_filesButton__1tias"};